import { SetStateAction } from 'react';

export enum RevNoteLevel {
  NONE,
  OPT,
  REQUIRED,
}
export interface AddRevisionNotesModalProps {
  commodityName: string;
  modalState: boolean;
  setModalState: React.Dispatch<SetStateAction<boolean>>;
}
export interface FormikAddNoteState {
  note: string;
}

export const initialValues: FormikAddNoteState = {
  note: '',
};
